import React from 'react';

import { useSelector } from 'hooks';
import { Spinner } from 'components/ui';
import { useGetGatesContextQuery } from 'modules/gates/service';
import { getIsVerifying } from 'modules/gates/selectors';

import Login from './components/Login';
import Verify from './components/Verify';

const Gates: React.FC = () => {
  const isVerifying = useSelector(getIsVerifying);
  const { isLoading, isSuccess } = useGetGatesContextQuery(undefined, { refetchOnMountOrArgChange: true });

  const Component = isVerifying ? Verify : Login;

  return (
    <>
      {isLoading && (
        <div className="min-h-screen flex justify-center items-center">
          <Spinner />
        </div>
      )}
      {isSuccess && <Component />}
    </>
  );
};

export default Gates;
